import { Component, OnInit } from '@angular/core';
import { BackendService } from '../shared/backend.service';
import { AuthService } from '../shared/auth.service';
import CONFIG from 'src/config';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AlertmessageService } from '../shared/alertmessage.service';

import { Router } from '@angular/router';
import { NotificationService } from '../notification.service';
import { ElementFinder } from 'protractor';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  providers: [DatePipe],
})
export class AccountComponent implements OnInit {
  updatePassword = false;

  clientdata: any;
  businessdatas: any;
  NIBNumber: any;
  FirstName: any;
  MiddleName: any;
  LastName: any;
  Email: any;
  Occupation: any;
  PassportNumber: any;
  address: any;
  request: any;
  phone: any;
  bankname: any;
  branch: any;
  accountnumber: any;

  Date: boolean; Dates: boolean;
  expirydate: boolean; expirydates: boolean;

  //Business info
  IdNumber: any;
  BusinessName: any;
  Trading: any;
  BusinessType: any;
  BusinessAddress: any;
  BusinessEmail: any;
  DateofInception: any;

  PrimaryPhone: any;
  PrimaryName: any;
  PrimaryEmail: any;
  SecondaryPhone: any;
  SecondaryName: any;
  SecondaryEmail: any;
  DateInception: boolean; DatesInception: boolean;
  dbDate: any;


  accountForm: FormGroup;
  businessaccountForm: FormGroup;

  editDate: any;
  documents: any;

  documents2: any;
  Passport: boolean;
  DriversLicense: boolean;
  National: boolean;

  fileInput: string = "'Upload Passport*";


  driversfileInput: string[] = [
    "Select Scanned Copy*",
    "Select Scanned Copy*",
  ];
  nationalfileInput: string[] = [
    "Select Scanned Copy*",
    "Select Scanned Copy*",
  ];
  Identifications: any;



  files: FileList;
  DriversLicensefiles: FileList;
  NationalInsuranceCardfiles: FileList;

  name: any;
  DriversLicensename: any;
  NationalInsuranceCardname: any;

  filestring: any;
  DriversLicensefilestring: any;
  NationalInsuranceCardfilestring: any;

  fileFormat: any;
  DriversLicensefileFormat: any;
  NationalInsuranceCardfileFormat: any;

  Birthday = new FormControl();
  loadingData1: boolean = true;
  uploadpassportfiles: boolean = false;
  UploadNationalInsurancefiles: boolean = false;


  reuploadpassportfiles: boolean = false;
  reUploadNationalInsurancefiles: boolean = false;



  //fileInput: string = 'Select file*';
  DriversLicensefileInput: string = 'Upload Driver’s License**';
  NationalInsuranceCardfileInput: string = 'Upload National Insurance Card**';

  Individual: boolean = false;
  Business: boolean = false;
  getEmailAddress: any;
  hidebankdetails = false;
  passportNumberEnable: boolean = false;
  drivingLincenceNumberEnable: boolean = false;
  constructor(
    public _backendservice: BackendService,
    public _authService: AuthService,
    public _formBuilder: FormBuilder,
    public _datePipe: DatePipe,
    public _alert: AlertmessageService,
    public _notificationService: NotificationService,
    public _router: Router,

  ) { }

  ngOnInit(): void {
    this.setForm();
    this.setForm1();
    this.pageLoad();
    this.getDocuments();
    this.getDocuments2();

  }


  formatDatabusiness(data) {
    data.map(d => {
      d.dateofInception = this._datePipe.transform(d.dateofInception.toString(), "MM/dd/yyyy");

    });
  }

  pageLoad() {


    // console.log(this._authService.LoginType)
    this.loadingData1 = false;
    if (this._authService.LoginType == "Individual") {
      // console.log(this._authService.LoginType)
      this.Individual = true;
      this.Business = false;

      //console.log(this._authService.LoginType)
      this._backendservice.getData(`${CONFIG.accountApiUrlBase}/${this._authService.NIBNumber}/${this._authService.LoginType}`)
        .subscribe(
          response => {
            // console.log(response)
            this.loadingData1 = true;
            this.formatData(response['data']);
            this.clientdata = response['data'];
            this.getEmailAddress = response['email'];
            //console.log(this.getEmailAddress)





            this.Identifications = this.clientdata[0].identificationtype;


            if (this.clientdata[0].identificationtype == "0                                       ") {
              // console.log("passportt")
              this.uploadpassportfiles = true;
              this.UploadNationalInsurancefiles = false;
              this.passportNumberEnable = true;
              this.drivingLincenceNumberEnable = false;
            }
            else if (this.clientdata[0].identificationtype == "1                                       ") {

              this.UploadNationalInsurancefiles = true;
              this.uploadpassportfiles = false;
              this.passportNumberEnable = false;
              this.drivingLincenceNumberEnable = true;
            }
            else {
              //console.log("EMPTY")
              this.UploadNationalInsurancefiles = false;
              this.uploadpassportfiles = false;
            }

            this.NIBNumber = this.clientdata[0].nibNumber;

            this.FirstName = this.clientdata[0].firstName;

            this.MiddleName = this.clientdata[0].middleName;

            this.LastName = this.clientdata[0].lastName;

            this.Email = this.clientdata[0].email;
            this.Occupation = this.clientdata[0].occupation;

            if (this.getEmailAddress == this.Email) {
              //console.log("test")
              this.hidebankdetails = true;
            }


            this.PassportNumber = this.clientdata[0].passPortNumber;

            this.Date = this.clientdata[0].birthday;

            this.expirydate = this.clientdata[0].expiryDate;

            this.phone = this.clientdata[0].individualPhone;
            this.address = this.clientdata[0].individualAddress;
            this.request = this.clientdata[0].request;

            this.bankname = this.clientdata[0].bankname;
            this.branch = this.clientdata[0].branch;
            this.accountnumber = this.clientdata[0].accountnumber
            let mask = "";

            if (this.accountnumber) {
              //  console.log(this.AccountNumber.trim().length);
              for (let i = 0; i < this.accountnumber.trim().length - 4; i++) {
                mask += "*";
              }

              let len = this.accountnumber.trim().length;
              //console.log(mask + this.AccountNumber.slice(len-4,len));

              this.accountnumber = mask + this.accountnumber.trim().slice(len - 4, len);
              // console.log(this.AccountNumber);
              // return mask + this.AccountNumber.slice(3,7)

            }
            if (this.clientdata[0].birthday == undefined) {
              ///// console.log("test birthdate")
              this.Date = false;
              this.Dates = true;
            }

            else {
              //// console.log(" date elde")
              this.Date = true;
              this.Dates = false;
            }
            this.clientdata.birthday = new Date(this.clientdata[0].birthday);

            if (this.clientdata[0].expiryDate == undefined) {
              ///// console.log("test birthdate")
              this.expirydate = false;
              this.expirydates = true;
            }
            else {
              //// console.log(" date elde")
              this.expirydate = true;
              this.expirydates = false;
            }
            this.clientdata.expiryDate = new Date(this.clientdata[0].expiryDate);
          })
    }

    // Business Logics
    else {
      this.Business = true;
      this.Individual = false;

      this._backendservice.getData(`${CONFIG.accountApiUrlBase}/${this._authService.NIBNumber}/${this._authService.LoginType}`)
        .subscribe(
          response => {
            this.loadingData1 = true;
            //console.log(response)
            this.formatDatabusiness(response['businessdata']);
            this.businessdatas = response['businessdata'];
            // console.log(this.businessdatas)

            this.IdNumber = this.businessdatas[0].nibNumber;
            this.BusinessName = this.businessdatas[0].bname;
            this.Trading = this.businessdatas[0].trading;
            this.BusinessType = this.businessdatas[0].btype;
            this.BusinessAddress = this.businessdatas[0].baddress;
            this.BusinessEmail = this.businessdatas[0].bemailaddress;
            this.DateofInception = this.businessdatas[0].dateofInception;
            //Primary Contacts
            this.PrimaryPhone = this.businessdatas[0].bPphone;
            this.PrimaryName = this.businessdatas[0].bPname;
            this.PrimaryEmail = this.businessdatas[0].bPemailaddress;
            //Secondary Contacts
            this.SecondaryPhone = this.businessdatas[0].sBphone;
            this.SecondaryName = this.businessdatas[0].sBname;
            this.SecondaryEmail = this.businessdatas[0].sBemailaddress;
            //Bank Info
            this.bankname = this.businessdatas[0].bbankname;
            this.branch = this.businessdatas[0].bbranch;
            this.accountnumber = this.businessdatas[0].baccountnumber


            let mask = "";

            if (this.accountnumber) {

              for (let i = 0; i < this.accountnumber.trim().length - 4; i++) {
                mask += "*";
              }

              let len = this.accountnumber.trim().length;


              this.accountnumber = mask + this.accountnumber.trim().slice(len - 4, len);


            }
            if (this.businessdatas[0].dateofInception == undefined) {

              this.DateInception = false;
              this.DatesInception = true;
            }

            else {

              this.DateInception = true;
              this.DatesInception = false;
            }
            this.businessdatas.dateofInception = new Date(this.businessdatas[0].dateofInception);
            //console.log(this.businessdatas.dateofInception)

            this.dbDate = new Date(this.businessdatas[0].dateofInception);
          })





    }


  }
  updateBusinessAccount(businessaccountData) {
    //console.log(businessaccountData)

  }

  IdentificationradioChange(event) {
    this.Identifications = event.value;
    if (this.Identifications == "0") {
      this.reuploadpassportfiles = true;
      this.reUploadNationalInsurancefiles = false;
    }
    else {
      this.reUploadNationalInsurancefiles = true;
      this.reuploadpassportfiles = false;
    }
  }
  getDocuments() {
    this._backendservice.getData(`${CONFIG.accountApiUrlBase}/${this._authService.NIBNumber}/${this._authService.LoginType}`)
      .subscribe(response => {
        this.documents = response['documents'];
        // console.log(this.documents);
        //// console.log(this.documents.length);
        this.FileOverwriteOption(this.documents.length);
      });
  }


  FileOverwriteOption(value) {
    //// console.log(value);
    for (let i = 0; i < value; i++) {
      //// console.log(this.documents[i]);
      if (this.documents[i] == "jpg" || this.documents[i] == "JPG" || this.documents[i] == "pdf" || this.documents[i] == "PDF") {
        //// console.log("test");
        this.Passport = true;
        break;
      }
    }

  }


  btnclickevent1() {
    this.Passport = false;
    //this.fileInput = 'Upload Passport*';
  }


  getDocuments2() {
    this._backendservice.getData(`${CONFIG.accountApiUrlBase}/${this._authService.NIBNumber}/${this._authService.LoginType}`)
      .subscribe(response => {
        this.documents2 = response['documents2'];
        //console.log(this.documents2);
        //// console.log(this.documents.length);
        this.FileOverwriteOption2(this.documents2.length);
      });
  }

  FileOverwriteOption2(value) {
    //// console.log(value);
    for (let i = 0; i < value; i++) {
      //// console.log(this.documents[i]);
      if (this.documents2[i] == "jpg" || this.documents2[i] == "JPG" || this.documents2[i] == "pdf" || this.documents2[i] == "PDF") {
        //// console.log("test");
        this.DriversLicense = true;
        this.National = true;
        break;
      }
    }

  }
  btnclickevent2() {
    this.DriversLicense = false;
    this.driversfileInput[0] = 'Upload Driver’s License*';
  }
  btnclickevent3() {
    this.National = false;
    this.nationalfileInput[0] = 'Upload National Insurance Card*';
  }

  updateAccount(newEnrollData) {
    //console.log(this.DriversLicense);
    // console.log( this.National);


    if (this.DriversLicense == true || this.National == true) {
      this.Identifications = '3';
    }

    this.loadingData1 = false;
    newEnrollData.Passportuploadfile = this.filestring;
    newEnrollData.passportFileName = this.name;
    ////console.log(this.fileFormat);


    //Driver’s License AND National Insurance Card
    //console.log(this.DriversLicensefilestring)
    newEnrollData.DriversLicenseuploadfile = this.DriversLicensefilestring;
    newEnrollData.DriversLicenseFileName = this.DriversLicensename;

    //console.log(this.NationalInsuranceCardfilestring)
    newEnrollData.NationalInsuranceCarduploadfile = this.NationalInsuranceCardfilestring;
    newEnrollData.NationalInsuranceCardFileName = this.NationalInsuranceCardname;

    newEnrollData.identificationtype = this.Identifications;
    newEnrollData.Birthday = this._datePipe.transform(newEnrollData.Birthday.toString(), "MM/dd/yyyy");
    newEnrollData.Expirydate = this._datePipe.transform(newEnrollData.Expirydate.toString(), "MM/dd/yyyy");
    //if (this.fileFormat != "image/jpeg" || this.fileFormat == "image/jpg") {

    //this._alert.openConfirmationDialog(" Please select a file of type jpg or jpeg ");

    if (newEnrollData.NewPassword != newEnrollData.ConfirmPassword) {
      //// console.log("test");
      this.loadingData1 = true;
      this._alert.openConfirmationDialog("New password and Confirm New password is not match.");
    }
    if (newEnrollData.request == null || newEnrollData.request == undefined
      || newEnrollData.request == "") {
      //// console.log("test");
      this.loadingData1 = true;
      this._alert.openConfirmationDialog("Request can not empty.");
      return true;
    }
    //}


    else {
      console.log(newEnrollData);
      this._backendservice.postData(newEnrollData, `${CONFIG.accountApiUrlBase}/save/${this._authService.NIBNumber}`)
        .subscribe(
          response => {
            if (response) {
              this.loadingData1 = true;
              this._notificationService.showNotification({ message: response['msg'], type: 'success' });
              this._router.navigate(['/login']);
              //this._alert.openConfirmationDialog(response['msg']);

            }
            else {
              ////console.log("test fail");
              this.loadingData1 = true;
              this._notificationService.showNotification({ message: response['msg'], type: 'error' });
            }
          });
    }

  }


  onFileChange(event) {
    this.files = event.target.files;



    if (this.files[0].name.length < 30) {
      var str = this.files[0].name;
      this.fileInput = str.slice(0, 30);
    } else {
      var str = this.files[0].name;
      this.fileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }
    //console.log(this.fileInput)

    if (
      this.files[0].type == "image/jpg" || this.files[0].type == "application/pdf" || this.files[0].type == "image/jpeg"
    ) {
      this.name = this.files[0].name;
      this.fileFormat = this.files[0].type;
      // console.log(this.files[0].type)
      // console.log(this.name);
      // console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoadded.bind(this);
      reader.readAsBinaryString(this.files[0]);
    }

    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }

  }
  _handleReaderLoadded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.filestring = btoa(binaryString); //Convaerting Binary String Data
    ////console.log(this.filestring);

  }


  onFileChangeDriversLicense(event) {
    this.DriversLicensefiles = event.target.files;


    if (this.DriversLicensefiles[0].name.length < 30) {
      var str = this.DriversLicensefiles[0].name;
      this.DriversLicensefileInput = str.slice(0, 30);
    } else {
      var str = this.DriversLicensefiles[0].name;
      this.DriversLicensefileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (
      this.DriversLicensefiles[0].type == "image/jpg" || this.DriversLicensefiles[0].type == "application/pdf" || this.DriversLicensefiles[0].type == "image/jpeg"
    ) {
      this.DriversLicensename = this.DriversLicensefiles[0].name;
      this.DriversLicensefileFormat = this.DriversLicensefiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedDriversLicense.bind(this);
      reader.readAsBinaryString(this.DriversLicensefiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }
  }
  _handleReaderLoaddedDriversLicense(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.DriversLicensefilestring = btoa(binaryString); //Convaerting Binary String Data
    ////console.log(this.filestring);

  }


  onFileChangeNationalInsuranceCard(event) {
    this.NationalInsuranceCardfiles = event.target.files;



    if (this.DriversLicensefiles[0].name.length < 30) {
      var str = this.NationalInsuranceCardfiles[0].name;
      this.NationalInsuranceCardfileInput = str.slice(0, 30);
    } else {
      var str = this.NationalInsuranceCardfiles[0].name;
      this.NationalInsuranceCardfileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }

    if (
      this.NationalInsuranceCardfiles[0].type == "image/jpg" || this.NationalInsuranceCardfiles[0].type == "application/pdf" || this.NationalInsuranceCardfiles[0].type == "image/jpeg"
    ) {
      this.NationalInsuranceCardname = this.NationalInsuranceCardfiles[0].name;
      this.NationalInsuranceCardfileFormat = this.NationalInsuranceCardfiles[0].type;
      //console.log(this.fileFormat);
      //// console.log(this.files);
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaddedNationalInsuranceCard.bind(this);
      reader.readAsBinaryString(this.NationalInsuranceCardfiles[0]);
    }
    else {
      this.loadingData1 = true;
      this._alert.openConfirmationDialo11("Please select a jpg/jpeg/pdf file to proceed.");
      return true;
    }

  }
  _handleReaderLoaddedNationalInsuranceCard(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.NationalInsuranceCardfilestring = btoa(binaryString); //Convaerting Binary String Data
    ////console.log(this.filestring);

  }





  OnCheckboxChange(event) {
    ////console.log(event.checked);
    if (event.checked)
      this.updatePassword = true;
    else
      this.updatePassword = false;
  }
  valueOfDate(value) {
    this.editDate = value;
    ////console.log(this.editDate);

    //this.editDate=this._datepipe.transform(value.toString(),"MM/dd/yyyy");

    ////console.log("test Date");
    //console.log(value, item);
  }

  setForm() {

    this.accountForm = new FormGroup({

      NIBNumber: new FormControl('', [Validators.required]),
      ConfirmPassword: new FormControl('', [Validators.required]),
      NewPassword: new FormControl('', [Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+.)(/]).{8,12}$')]),
      FirstName: new FormControl('', [Validators.required]),
      MiddleName: new FormControl('', [Validators.required]),
      LastName: new FormControl('', [Validators.required]),
      Email: new FormControl(''),
      PassportNumber: new FormControl('', [Validators.required]),
      Birthday: new FormControl(''),
      Expirydate: new FormControl(''),
      passportFile: new FormControl('', [Validators.required]),
      updatePasswordChecked: new FormControl(''),

      //Raghava added new spec's
      bankname: new FormControl(''),
      branch: new FormControl(''),
      accountnumber: new FormControl(''),
      IndividualAddress: new FormControl('', [Validators.required]),
      IndividualPhone: new FormControl('', [Validators.required]),
      request: new FormControl('', [Validators.required]),
      Occupation: new FormControl('', [Validators.required]),
    });
  }
  setForm1() {
    this.businessaccountForm = new FormGroup({

      ID: new FormControl(''),
      Bname: new FormControl('', [Validators.required]),
      trading: new FormControl(''),
      Btype: new FormControl('', [Validators.required]),
      Baddress: new FormControl('', [Validators.required]),
      Bemailaddress: new FormControl('', [Validators.required]),
      DateofInception: new FormControl('', [Validators.required]),

      //Primary
      BPemailaddress: new FormControl('', [Validators.required]),
      BPname: new FormControl('', [Validators.required]),
      BPphone: new FormControl('', [Validators.required]),
      //Secondary

      SBname: new FormControl(''),
      SBemailaddress: new FormControl(''),
      SBphone: new FormControl(''),
      //Bank Info
      bankname: new FormControl(''),
      branch: new FormControl(''),
      accountnumber: new FormControl(''),

      //documents

      beneficialdocs: new FormControl(''),
      authorizeddocs: new FormControl(''),
      Businessdocs: new FormControl(''),

      passportFile: new FormControl('', [Validators.required]),
    });
  }




  formatData(data) {
    data.map(d => {
      d.birthday = this._datePipe.transform(d.birthday.toString(), "MM/dd/yyyy");
      d.expirydate = this._datePipe.transform(d.expiryDate.toString(), "MM/dd/yyyy");
    });
  }

}
